import axios from "axios";
import { applyTheme, saveTheme } from "@/services/themeService.js";

export default {
  async Login({ commit }, Form) {
    try {
      const response = await axios.post("/login", Form);
      localStorage.setItem("token", response.data.data.token);
      localStorage.setItem("is_admin", response.data.data.is_admin ? "1" : "0");
      localStorage.setItem("permissions", JSON.stringify(response.data.data.permissions || []));
      commit("setUser", { user: response });

      // Apply theme saved on server if available, else keep local
      const serverTheme = response.data.data.theme;
      if (serverTheme) {
        commit("setTheme", serverTheme);
        applyTheme(serverTheme);
      }

      return response;
    } catch (error) {
      return error.response;
    }
  },

  logout({ commit }) {
    commit("logout");
  },

  // Refreshes is_admin/permissions for an already-open session using the
  // existing token — called on every app boot so a session that predates a
  // permission change picks it up on next page load, without forcing a
  // logout/login round trip.
  async refreshPermissions({ commit, state }) {
    if (!state.token) return;
    try {
      const { data } = await axios.get("/me");
      localStorage.setItem("is_admin", data.data.is_admin ? "1" : "0");
      localStorage.setItem("permissions", JSON.stringify(data.data.permissions || []));
      commit("setPermissions", {
        isAdmin: !!data.data.is_admin,
        permissions: data.data.permissions || [],
      });
    } catch {
      // Non-fatal — keep whatever was already in localStorage (e.g. token
      // expired/offline; the normal 401 flow elsewhere handles that case).
    }
  },

  setTheme({ commit, state }, theme) {
    commit("setTheme", theme);
    applyTheme(theme);

    // Sync to server (non-blocking)
    if (state.token) {
      axios.post("/user/update-theme", { theme }).catch(() => {});
    }
  },
};
